export const TRADEVAN = 'tradevan';
export const CETUSTEK = 'cetustek';
